<template>
  <div style="height: calc(100vh - 208px);" >
    <!-- <hear></hear> -->
    <div class="xtoubu">
      <div class="Guarantee_status_box">
        <div
          style="padding: 0 20px; display: flex; justify-content: space-between"
        >
          <div style="display: flex">
            <el-button
              @click="shuaxin"
              type="info"
              icon="el-icon-refresh-right"
              class="anniu"
            ></el-button>
            <!-- <el-button
                class="anniu"
                type="success"
                icon="el-icon-plus"
                @click="handleAdd"
                >添加</el-button> -->
          </div>

          <div
            style="display: flex; justify-content: flex-end;"
          >
            <!-- <el-input
                class="anniu"
                v-model="params.kws"
                placeholder="请输入"
              ></el-input>
              <el-button
                class="anniu"
                type="primary"
                icon="el-icon-search"
                @click="sousuo"
              ></el-button> -->
            <el-row style="display: flex; justify-content: flex-end;" class="mb8">
              <el-col :span="19" class="seach">
                <el-input clearable v-model="params.merOrderId" placeholder="请输入支付订单号"></el-input>
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="sousuo"
                ></el-button>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="shenflex">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            class="table xtable"
            stripe
            border
            align="center"
            highlight-current-row
            v-loading="loading"
            @selection-change="handleSelectionChange"
          >
            <el-table-column align="center" type="selection" width="55">
            </el-table-column>
            <el-table-column
              align="center"
              prop="merOrderId"
              :show-overflow-tooltip="true"
              label="支付编号"
              width="300"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="username"
              :show-overflow-tooltip="true"
              label="付款人"
              width="120"
            >
            </el-table-column>

            <!-- <el-table-column align="center" prop="khsh " :show-overflow-tooltip="true" width="220" label="申请公司税号"> </el-table-column> -->
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="zftype"
              width="120"
              label="付款类型"
            >
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="money"
              width="120"
              label="支付金额"
            >
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="cp_name"
              width="260"
              label="产品名称"
            >
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="guarantee_company_name"
              width="300"
              label="出函机构名称"
            >
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="bankname"
              width="120"
              label="银行"
            >
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="bankcode"
              width="120"
              label="银行卡号"
            >
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="bankaccount"
              width="120"
              label="银行账号"
            >
            </el-table-column>
            <!-- <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="image"
              width="120"
              label="支付凭证"
            >
            </el-table-column> -->
            <!-- <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="rebankname"
              width="120"
              label="付款银行名称"
            >
            </el-table-column> -->
            <!-- <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="rebankaccount"
              width="120"
              label="付款银行账号"
            >
            </el-table-column> -->
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="state"
              width="220"
              label="支付状态"
            >
              <!-- <template slot-scope="scope">{{
                scope.state ==0 ? "未支付" : "支付"
              }}</template> -->
              <template slot-scope="scope">{{
                scope.row.state == 0 ? "未支付" : "支付"
              }}</template>
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              width="220"
              prop="createtime"
              label="支付时间"
            >
              <template slot-scope="scope">{{
                scope.row.createtime | dateFormat
              }}</template>
            </el-table-column>
            <!-- <el-table-column align="center" prop="createtime" width="220" label="分配时间"> </el-table-column> -->
            <!-- <el-table-column align="center" prop="createtime" label="创建时间" width="200">
      </el-table-column> -->
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="beizhu"
              width="220"
              label="备注"
            >
              <!-- scope.row.state ==0 ? "未支付" : "支付" -->
              <!-- <template slot-scope="scope">{{
               scope.row.state
              }}</template> -->
            </el-table-column>
            <el-table-column
              fixed="right"
              align="center"
              width="120"
              label="操作"
            >
              <template slot-scope="scope">
                <!-- <el-button size="mini" @click="handleUpdate(scope.row)"
            >添加步骤</el-button
          >
             <el-button size="mini" @click="buzhlist(scope.row)"
            >步骤列表</el-button
          > -->
                <el-button size="mini" @click="handleUpdate(scope.row)"
                  >申请发票</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-dialog
        title="申请发票"
        :visible.sync="opens"
        v-dialogDrag
        append-to-body
        width="50%"
        :close-on-click-modal="false"
        custom-class="publicDialog"
      >
        <el-form ref="form" :model="casd" :rules="rules" label-width="80px">
          <div style="display: flex; justify-content: center; margin-top: 20px">
            <div>
              <el-form-item label="发票类型">
                <el-radio-group v-model="radio">
                  <el-radio :label="1">纸质专票</el-radio>
                  <el-radio :label="2">纸质普票</el-radio>
                  <el-radio :label="3">电子普票</el-radio>
                  <el-radio :label="4">电子专票</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="radio == '1' || radio == '2'" label="开户行">
                <el-input v-model="casd.khh"></el-input>
              </el-form-item>
              <el-form-item
                v-if="radio == '1' || radio == '2'"
                label="银行账户"
              >
                <el-input v-model="casd.khyhzh"></el-input>
              </el-form-item>
              <el-form-item label="开票备注">
                <el-input type="textarea" v-model="casd.bzinfo"></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div style="display: flex; justify-content: center">
          <!-- <el-button @click="buzhoulis" type="primary">确定</el-button> -->
          <el-button @click="opens = !opens">取消</el-button>
          <el-button
            style="margin: 0px; margin-left: 20px"
            @click="bucioncheng"
            type="primary"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        title="添加流程"
        :visible.sync="open"
        width="400px"
        append-to-body
      >
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
          <el-form-item label="流程名称">
            <el-input v-model="liuch.lc_name"></el-input>
          </el-form-item>
          <div
            style="display: flex; justify-content: center; margin-top: 20px"
          ></div>
        </el-form>
      </el-dialog>
      <div class="block">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentpage"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="limit"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { paylist } from "@/api/system/liucheng";
// import hear from ".././../components/hear.vue";
import axios from "axios";
export default {
  components: {
    // hear
  },
  name: "progress1",
  data() {
    return {
      total: null,
      currentpage: null,
      // params: {
      //   limit: 4,
      //   offset: 0,
      //   keywords: "",
      //   // user_id: sessionStorage.getItem("user_id"),
      // },
       loading: true,
      BidingDocumentList: [],
      radio: 1,
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      opens: false,
      params: {
        offset: 0,
        limit: 10,
        state: 2,
        merOrderId:null,
        // user_id: sessionStorage.getItem("id"),
      },
      total: null,
      limit: null,
      // 表单参数
      form: {
        name1: "",
        name2: "",
        name3: "",
        dept: "",
        user_id: "",
        lc_id: "",
        bm_id: "",
        bm_name: "",
        staff_id: "",
        staff_name: "",
        operation: "",
        dengji: ""
      },
      // 表单校验

      options1: [], //选择部门
      options2: [], //选择职位
      btype: [],
      options3: [], //选择小组
      options4: [], //选择小组
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      tableData: [],
      multipleSelection: [],
      liuch: {
        user_id: sessionStorage.getItem("id"),
        lc_name: "",
        gtype: ""
      },
      buzhl: false,
      buzhilist: [],
      casd: {
        apply_number: "",
        fplxdm: "",
        bzinfo: "",
        khh: "",
        khyhzh: ""
      },
      rules: {
        khh: [
          {
            required: true,
            message: "请输入开户行",
            trigger: "blur"
          }
        ],
        khyhzh: [
          {
            required: true,
            message: "请输入银行账号",
            trigger: "blur"
          }
        ],
        bzinfo: [
          {
            required: true,
            message: "请输入备注",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    // this.getBhlist();
    this.zhifu();
  },
  methods: {
    sousuo() {
      this.shuaxin()
    },
    handleUpdate(e) {
      (this.casd = {
        apply_number: "",
        fplxdm: "",
        bzinfo: "",
        khh: "",
        khyhzh: ""
      }),
        // this.reset();
        console.log(e.apply_number);
      this.casd.apply_number = e.apply_number;
      this.opens = true;
      //   this.title = "修改员工信息";
    },
    bucioncheng() {
      if (this.radio == 1) {
        this.casd.fplxdm = "004";
      }
      if (this.radio == 2) {
        this.casd.fplxdm = "007";
      }
      if (this.radio == 3) {
        this.casd.fplxdm = "026";
      }
      if (this.radio == 4) {
        this.casd.fplxdm = "028";
      }
      //   this.$refs['form'].validate(valid => {
      //     console.log("casd发窍",valid)
      //   if (!valid) return
      //   // TODO 提交表单
      // })
      var bbc = this.casd;
      axios({
        url: "https://api.hnzyxsbh.com/api/fapiao/sqfapiao",
        method: "post", // params: '必须是一个无格式对象 query参数',
        data: {
          ...bbc
        },
        timeout: 1000,
        headers: {
          token: sessionStorage.getItem("token")
        }
      })
        .then(res => {
          console.log("发票pdf", res.data);
          if (res.data.code == 1) {
            this.opens = false;
          } else {
            this.$message.error(res.data.msg);
          }
          // this.$router.push("/BidSecurity/Bidpayment");
        })
        .catch(err => {
          console.log("失败", err.response.data);
          this.$notify.error({
            message: err.response.data.msg
          });
        });
    },
    handlesc(e) {
      console.log(e);
      var bbc = {
        djbh: e.djbh
      };
      // return
      axios({
        url: "https://api.hnzyxsbh.com/api/fapiao/get_pdf",
        method: "post", // params: '必须是一个无格式对象 query参数',
        data: {
          ...bbc
        },
        timeout: 1000,
        headers: {
          token: sessionStorage.getItem("token")
        }
      })
        .then(res => {
          console.log("发票pdf", res.data);
          if (res.data.code == 1) {
            let link = document.createElement(res.data.pdf_url);
            link.style.display = "none";
            link.style.download = "";
            link.target = "_blank";
            link.href = this.filepath;
            link.setAttribute("download", ".pdf");
            // +'.pdf' 通过不同的后缀名下载不同的文件
            //这里下载的是pdf格式的文件，拿到接口里的res也必须是pdf的文件流
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href); //URL.revokeObjectURL() 静态方法用来释放一个之前通过调用 URL.createObjectURL() 创建的已经存在的 URL 对象。当你结束使用某个 URL 对象时，应该通过调用这个方法来让浏览器知道不再需要保持这个文件的引用了。
            document.body.removeChild(link);
          } else {
            this.$message.error(res.data.msg);
          }
          // this.$router.push("/BidSecurity/Bidpayment");
        })
        .catch(err => {
          console.log("失败", err.response.data);
          this.$notify.error({
            message: err.response.data.msg
          });
        });
    },
    buzhlist(e) {
      this.buzhl = true;
    },
    zhifu() {
      paylist(this.params).then(res => {
        console.log("发票列表", res);
        if (res.data.code == 1) {
          this.loading = false;
          this.limit = res.data.data.total;
          this.tableData = res.data.data.rows;
        } else {
          console.log("失败", err.response.data);
          this.$notify.error({
            message: err.response.data.msg
          });
        }
      });
      return;
      var bbc = this.params;
      axios({
        url: "https://api.hnzyxsbh.com/api/fapiao/fplist",
        method: "post", // params: '必须是一个无格式对象 query参数',
        data: {
          ...bbc
          //  ...cion
        },
        timeout: 1000,
        headers: {
          // token: sessionStorage.getItem("token"),
        }
      })
        .then(res => {
          console.log("发票列表", res);
          if (res.data.code == 1) {
            this.limit = res.data.data.data.total;
            this.tableData = res.data.data.data.list;
          }
          // else {
          //   this.$message.error(res.data.mag);
          // }
          // this.$router.push("/BidSecurity/Bidpayment");
        })
        .catch(err => {
          console.log("失败", err.response.data);
          this.$notify.error({
            message: err.response.data.msg
          });
        });
    },
    shuaxin() {
     var that=this
      setTimeout(function() {
        that.zhifu();
      }, 500);
      this.loading = true;
    },
    getBhlist() {
      bhlist(this.params).then(res => {
        this.BidingDocumentList = res.data.data.rows;
        this.total = res.data.data.total;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.params.limit = val;
      this.zhifu();
    },
    handleCurrentChange(val) {
      this.params.offset = parseInt(val - 1);
      // * this.params.limit;
      this.currentpage = val;
      this.zhifu();
    }
  }
};
</script>

<style scoped>
html body {
  height: 100% !important;
  /* background-color: #f5f6fa !important; */
}
.block {
  padding: 10px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.state_bh {
  font-size: 18px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #1890ff;
  width: 143px;
  height: 47px;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  line-height: 47px;
  text-align: center;
  border: 2px solid #1890ff;
}
.shenflex {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  padding-top: 10px;
}
.status_bg1 {
  width: 85px;
  height: 40px;
  background-color: #ff1818;
  border-bottom-left-radius: 10px;
  position: relative;
  bottom: 87%;
  left: 94%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 18px;
}

.status_bg {
  width: 85px;
  height: 40px;
  background-color: #1795ff;
  border-bottom-left-radius: 10px;
  position: relative;
  bottom: 87%;
  left: 94%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 18px;
}

.examine_btn {
  width: 143px;
  height: 47px;
  color: #1795ff;
}

.bubble {
  color: #ffffff;
  font-size: 12px;
  width: 94px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 31px;
  margin-left: 20px;
  background-image: url("../../assets/Guarantee/Bubble.png");
}

.Guarantee_details {
  justify-content: space-around;
}

.Ge_box {
  width: 113px;
  height: 33px;
  border-radius: 4px;
  background-color: #1795ff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  margin-left: 15px;
}

.Guarantee_num {
  width: 219px;
  height: 48px;
  color: #333333;
}

.Guarantee_status_box {
flex:1;
display: flex;
  flex-direction: column;
}

.Guarantee_status {
  width: 95%;
  height: 162px;
  margin-bottom: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
}

.Guarantee_examine {
  color: #333333;
  font-size: 24px;
  margin-left: 30px;
  margin-top: 10px;
  font-weight: Bold;
  margin-bottom: 36px;
}

::v-deep .el-table__body-wrapper {
  height: 69vh !important;
  /* margin-top: 10px; */
  overflow: auto !important;
}
</style>
<style scoped></style>



// WEBPACK FOOTER //
// src/view/Guarantee/zhifus.vue